import { APIClient, getLoggedinUser, setAuthorization } from './apiCore';
import * as url from './urls';

const api = new APIClient();

const getContacts = (search: string, page: number, chunkSize: number) => {
    const userProfileSession = getLoggedinUser();
    setAuthorization(userProfileSession.data.acces_token);
    return api.get(url.GET_CONTACTS, {
        params: {
            'where[OR][0][firstName][contains]': search,
            'where[OR][1][lastName][contains]': search,
            'where[OR][2][phoneNumber][contains]': search,
            'include[Conversation]': true,
            'orderBy[firstName]': 'asc',
            take: chunkSize,
            page
        }
    });
};

const createContact = (data: object) => {
    const userProfileSession = getLoggedinUser();
    setAuthorization(userProfileSession.data.acces_token);
    return api.create(url.CREATE_CONTACT, data);
};

const editContact = (data: object, personId: string) => {
    const userProfileSession = getLoggedinUser();
    setAuthorization(userProfileSession.data.acces_token);
    return api.update(url.EDIT_CONTACT(personId), data);
};

const deleteContact = (personId: string) => {
    const userProfileSession = getLoggedinUser();
    setAuthorization(userProfileSession.data.acces_token);
    return api.delete(url.DELETE_CONTACT(personId));
};

export { getContacts, createContact, editContact, deleteContact };
